export interface ISlidersState {}

let slidersState: ISlidersState = {};

export default slidersState;